import { useEffect } from "react";

import { Cards } from "./components/cards";
import { PlayPause } from "./components/control/PlayPause/PlayPause";
import { Reset } from "./components/control/Reset/Reset";
import { Header } from "./components/layout/header/Header";

import { startAudioEngine } from "./audioEngine";

import "./App.css";
import { useSoundMixer } from "./hooks/useSoundMixer";
import { SoundContext } from "./components/context/soundMixerContext";
import { Loader } from "./components/loader/Loader";
import { Share } from "./components/control/Share/Share";

function App() {
  const soundMixer = useSoundMixer();

  useEffect(() => {
    startAudioEngine(soundMixer.setIsSoundsLoaded);
  }, [soundMixer.setIsSoundsLoaded]);

  return (
    <div className="App">
      <SoundContext value={soundMixer}>
        <div>
          <Header />
          <div className="controlls">
            <PlayPause />
            <div className="controlls-sub">
              <Reset />
              <Share />
            </div>
          </div>
          {soundMixer.isSoundsLoaded ? (
            <Loader />
          ) : (
            <div>
              <Cards />
            </div>
          )}
        </div>
      </SoundContext>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
